import { useSearchParams } from '@solidjs/router';
import type { JSX } from 'solid-js';
import { AdminGate } from '../components/AdminGate';
import { AdminOrgsPanel } from '../components/AdminOrgsPanel';
import { billingFilterFrom } from '../lib/admin';
import { SESSION_TOKEN } from '../lib/session';

// Admin org management route. Thin: <AdminGate/> keeps the panel (and its
// `/v1/admin/accounts` reads + `account` MCP writes) behind the closed-beta
// staff wall. `token` is injectable for tests; the router mounts with no props.
//
// The URL OWNS the billing filter: `?billing=paying|comped|paused` is what the
// overview's billing band links to (#5726), and the panel's select writes it
// back, so a narrowed list is a link an operator can paste. Parsed here, at the
// route, and handed down — the panel stays Router-free (`AdminGrants` does the
// same). An unknown value reads as no filter (`billingFilterFrom`).
//
// The URL owns the OPEN ORG too: `?account=<id>` is what a membership on a
// person's page links to (`adminOrgHref`, #5727), and what a row's link names.

/** The open org's id, or null; a repeated param takes its first value. */
const accountFrom = (raw: string | string[] | undefined): string | null =>
  (Array.isArray(raw) ? raw[0] : raw)?.trim() || null;

export function AdminOrgs(props: { token?: string | null } = {}): JSX.Element {
  const token = props.token ?? SESSION_TOKEN;
  const [params, setParams] = useSearchParams();
  return (
    <AdminGate token={token}>
      <AdminOrgsPanel
        token={token}
        billing={() => billingFilterFrom(params['billing'])}
        onBilling={(next) => setParams({ billing: next ?? undefined }, { replace: true })}
        selected={() => accountFrom(params['account'])}
      />
    </AdminGate>
  );
}
